import React, { PureComponent, ChangeEvent } from 'react';
import { Trans } from 'react-i18next';
import { FormikProps } from 'formik';
import Loading from '@jg/loading';
import Alert from '@jg/alert';
import AmountInput from '../AmountInput/AmountInput';
import FormError from '../FormError/FormError';

type TeamMembersTargetFormValues = {
  teamMembersTarget: number | string;
};

interface ITeamMembersTargetForm
  extends FormikProps<TeamMembersTargetFormValues> {
  isInFlight?: boolean;
  isSuccess?: boolean;
  currencyCode: string;
}

class TeamMembersTargetForm extends PureComponent<ITeamMembersTargetForm> {
  onTeamMembersTargetChange = (
    event: Pick<ChangeEvent<HTMLInputElement>, 'target'>,
  ) => {
    const { setFieldValue } = this.props;
    setFieldValue('teamMembersTarget', event.target.value);
  };

  render() {
    const {
      handleSubmit,
      values,
      errors,
      touched,
      currencyCode,
      handleBlur,
      isInFlight,
      dirty,
      isSuccess,
    } = this.props;
    const isButtonDisabled: boolean = Boolean(
      isInFlight || errors.teamMembersTarget || !dirty,
    );

    const displayTeamMembersTargetErrorMessage = Boolean(
      touched.teamMembersTarget && errors.teamMembersTarget,
    );

    return (
      <form
        onSubmit={handleSubmit}
        autoComplete="off"
        className="jg-space-mvmd"
      >
        <AmountInput
          id="teamMembersTarget"
          name="teamMembersTarget"
          intlId="content.editmembers.teammemberstarget.heading"
          value={values.teamMembersTarget}
          defaultCurrency={currencyCode}
          onBlur={handleBlur}
          onChange={this.onTeamMembersTargetChange}
          hasValidationError={displayTeamMembersTargetErrorMessage}
          min={0}
        />
        {displayTeamMembersTargetErrorMessage && (
          <FormError message={errors.teamMembersTarget} />
        )}
        <p className="jg-text jg-space-mtxs">
          <Trans i18nKey="content.editmembers.teammemberstarget.defaulttarget.info" />
        </p>
        <div className="jg-tc-button-container jg-tc-button-container__align-left">
          <button
            disabled={isButtonDisabled}
            type="submit"
            id="jg-tc-set-members-target-button"
            className="jg-btn jg-space-mbml jg-space-mtsm"
          >
            {isInFlight ? (
              <Loading size="small" colour="purple" />
            ) : (
              <Trans i18nKey="content.editmembers.button.savechanges" />
            )}
          </button>
        </div>
        {isSuccess && (
          <Alert type="success" displayType="inline">
            <Trans i18nKey="global.alert.success" />
          </Alert>
        )}
      </form>
    );
  }
}

export default TeamMembersTargetForm;
